export default (sitemap: SitemapBuilder) =>
{
    sitemap.after('[[[System]]]', [
        {
            name: '[[[OCR]]]',
            short: '[[[OCR]]]',
            icon: 'fa-solid fa-expand',
            namespace: 'Ideo.Core.Workspace.Application.Permissions.AiOcr',
            children: [
                {
                    name: '[[[Modele AI / Programy]]]',
                    icon: 'far fa-fw fa-star',
                    route: 'md-programs',
                    auth: { all: ['ProgramsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opisu usługi]]]',
                            route: 'md-programs-add',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opisu usługi]]]',
                            route: 'md-programs-edit',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Paragony]]]',
                    icon: 'far fa-fw fa-receipt',
                    route: 'ai-ocr-receipts',
                    auth: { all: ['ReceiptsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie paragonu]]]',
                            route: 'ai-ocr-receipt-add',
                            auth: { all: ['ReceiptsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie paragonów]]]',
                            route: 'ai-ocr-receipts-add',
                            auth: { all: ['ReceiptsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja paragonu]]]',
                            route: 'ai-ocr-receipt-edit',
                            auth: { all: ['ReceiptsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Tłumaczenia katalogu]]]',
                    icon: 'far fa-fw fa-language',
                    route: 'md-catalog-translations',
                    auth: { all: ['CatalogTranslationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie tłumaczenia]]]',
                            route: 'md-catalog-translations-add',
                            auth: { all: ['CatalogTranslationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja tłumaczenia]]]',
                            route: 'md-catalog-translations-edit',
                            auth: { all: ['CatalogTranslationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
